import DOMPurify from 'dompurify';

function sanitizeHtml(htmlContent) {
    return {__html: DOMPurify.sanitize(htmlContent)};
}
 
export default sanitizeHtml;